export enum routesEndpoints {
  HOME = '/',
  PRODUCTS = '/produtos',
  PRODUCT = '/produto',
  CHECKOUT = '/oldcheckout',
  NEW_CHECKOUT = '/checkout',
  CHECKOUT_REMAKE = '/checkout/remake',
  PAINEL = '/panel',
  SUMMARY = '/summary',
  SUMMARY_FINISH = '/summary/finish',
  ACCOUNT = '/account',
  ACCOUNT_PAYMENT = '/account/payment',
  ACCOUNT_ADDRESS = '/account/address',
  ACCOUNT_FAVORITE = '/account/favorite',
  NEW_ACCOUNT = '/minha-conta',
  NEW_ACCOUNT_PAYMENT = '/minha-conta/cartoes',
  NEW_ACCOUNT_ADDRESS = '/minha-conta/endereco',
  NEW_ACCOUNT_ORDERS = '/minha-conta/meus-pedidos',
  NEW_ACCOUNT_CANCEL = '/minha-conta/cancelar-conta',
  SIGNIN = '/signin',
  SIGNUP = '/signup',
  FORGOT_PASSWORD = '/forgot-password',
  VERIFICATION_MAIL = '/verification-mail',
  CONFIRMATION_MAIL = '/confirmation-mail',
  STORE_LOCATOR = '/store-locator',
  ORDERS = '/orders',
  ORDERS_DETAIL = '/orders/detail',
  AGREEMENTS = '/agreements',
  AGREEMENT = '/agreement',
  REDEFINE_PASSWORD = '/reset-senha'
}
